import { useState, useEffect } from 'react';
import { useQueryClient } from 'react-query';
import useNotebookHostRetrieve from 'hooks/useNotebookHostRetrieve';
import { enableNotebookServer } from 'api/services/notebook';
import useAccountStore from 'store/accountStore';
import withNotification from 'components/hoc/withNotification';
import JobNotebookContent from './JobNotebookContent';

const JobNotebook = () => {
  const [isNotebookStarting, setIsNotebookStarting] = useState(false);
  const [isNotebookLoading, setIsNotebookLoading] = useState(false);
  const [serverError, setServerError] = useState(false);
  const queryClient = useQueryClient();

  const {
    notebookUrl,
    isNotebookKilling,
  } = useAccountStore(
    (state) => ({
      notebookUrl: state.account.notebookUrl,
      isNotebookKilling: state.account.isNotebookKilling,
    }),
  );

  const {
    error,
    refetch,
    isRefetching,
    isLoading,
  } = useNotebookHostRetrieve();

  useEffect(() => () => {
    queryClient.invalidateQueries(['notebookServer']);
  }, []);

  useEffect(() => {
    if (!isLoading && !isRefetching && (error || !notebookUrl)) {
      setIsNotebookLoading(false);
    } else if (isRefetching && (!error || !notebookUrl)) {
      setIsNotebookLoading(true);
      setIsNotebookStarting(true);
    }
  }, [isLoading, isRefetching, error, notebookUrl]);

  useEffect(() => {
    if (error || serverError || notebookUrl) {
      setIsNotebookStarting(false);
      setIsNotebookLoading(false);
    }
  }, [error, serverError, notebookUrl]);

  const verify = () => {
    setIsNotebookStarting(false);
  };

  const handleStartNotebook = async () => {
    setIsNotebookStarting(true);
    try {
      const isNotebookAvailable = await enableNotebookServer();
      if (isNotebookAvailable) {
        await refetch();
      }
    } catch (err) {
      setServerError(err);
    }
  };

  return (
    <JobNotebookContent
      isNotebookStarting={isNotebookStarting}
      isNotebookLoading={isNotebookLoading}
      isNotebookKilling={isNotebookKilling}
      notebookUrl={notebookUrl}
      error={error}
      serverError={serverError}
      handleStartNotebook={handleStartNotebook}
      verify={verify}
    />
  );
};

export default withNotification(JobNotebook);
